import { BOX_TRUCK_DOC_LABELS, BoxTruckDocument } from '@numeo/types-core'
import { fetchBoxTruckDriverDocumentBlobUrl } from '../services/boxTruckLoadsApi'
import { DocumentsCompact } from './DocumentsCompact'

/**
 * Compact, read-only documents strip for the driver quick view: one wrap-line of small chips (type label +
 * file), each opening an IN-PLACE lightbox preview (no new tab). Managing documents (upload/remove) lives in
 * the Edit mode's full list. Types with no files are simply not rendered — no "Not uploaded" noise.
 *
 * The rendering is `DocumentsCompact`, shared with the owner and vehicle strips. What is local to drivers is
 * the address: their files are addressed by the private GCS path rather than by a document id.
 */
export const DriverDocumentsCompact = ({
    driverId,
    docs,
    fetchBlobUrl = fetchBoxTruckDriverDocumentBlobUrl,
}: {
    driverId: string
    docs: BoxTruckDocument[]
    /** Blob fetcher — defaults to the claim-gated My Drivers endpoint; the verification review passes its
     *  own queue-scoped one. */
    fetchBlobUrl?: (driverId: string, gcsPath: string) => Promise<string>
}) => (
    <DocumentsCompact
        docs={docs}
        labels={BOX_TRUCK_DOC_LABELS}
        scope="driver"
        keyOf={(doc) => doc.gcsPath}
        openFor={(doc) => fetchBlobUrl(driverId, doc.gcsPath)}
        emptyText="No documents uploaded yet — use Edit to add them."
    />
)
